import { createAction } from '../utils';
// main form
export var FORM_LOAD = '[Form] load';
export var FORM_ACT_LOAD = '[Form] load act form';
export var FORM_FREE_LOAD = '[Form] load free form';
export var FORM_LOAD_SUCCESS = '[Form] load success';
export var FORM_LOAD_ERROR = '[Form] load error';
export var FORM_NEXT = '[Form] next';
export var FORM_NEXT_SUCCESS = '[Form] next success';
export var FORM_NEXT_ERROR = '[Form] next error';
export var FORM_SAVE = '[Form] save';
export var FORM_FREE_SAVE = '[Form] free form save';
export var FORM_SAVE_SUCCESS = '[Form] save success';
export var FORM_SAVE_ERROR = '[Form] save error';
export var FORM_REFRESH = '[Form] refresh';
export var FORM_FREE_REFRESH = '[Form free] refresh';
export var FORM_REFRESH_SUCCESS = '[Form] refresh success';
export var FORM_REFRESH_ERROR = '[Form] refresh error';
export var FORM_ADD_BLOCK = '[Form] add block';
export var FORM_FREE_ADD_BLOCK = '[Form free] add block';
export var FORM_ADD_BLOCK_SUCCESS = '[Form] add block success';
export var FORM_ADD_BLOCKS_SUCCESS = '[Form] add blocks success';
export var FORM_ADD_BLOCK_ERROR = '[Form] add block error';
export var FORM_REMOVE_BLOCK = '[Form] remove block';
export var FORM_FREE_REMOVE_BLOCK = '[Form free] remove block';
export var FORM_REMOVE_BLOCK_SUCCESS = '[Form] remove block success';
export var FORM_REMOVE_BLOCKS_SUCCESS = '[Form] remove blocks success';
export var FORM_REMOVE_BLOCK_ERROR = '[Form] remove block error';
export var FORM_SILENT_UPDATE = '[Form] silent update';
export var FORM_FREE_SILENT_UPDATE = '[Form free] silent update';
export var FORM_CANCEL = '[Form] cancel';
export var FORM_CLICK_REQUEST = '[Form] click request';
export var FORM_CLICK_REQUEST_SUCCESS = '[Form] click request success';
export var FORM_CLICK_REQUEST_ERROR = '[Form] click request error';
export var FORM_NAVIGATE_WITH_INITIATOR = '[Form] navigate with initialor';
export var FORM_NAVIGATE_WITH_PARAMS = '[Form] navigate with params';
export var FORM_CHANGE_MARKER = '[Form] change marker';
export var FORM_MOUNT = '[Form] mount';
// modal form
export var FORM_MODAL_LOAD = '[Form] child load';
export var FORM_MODAL_LOAD_SUCCESS = '[Form] child load success';
export var FORM_MODAL_LOAD_ERROR = '[Form] child load error';
export var FORM_MODAL_CLOSE = '[Form] child close';
export var FORM_MODAL_CLOSE_SUCCESS = '[Form] child close success';
export var FORM_MODAL_CLOSE_ERROR = '[Form] child close error';
export var FORM_MODAL_CANCEL = '[Form] child cancel';
// internal
export var FORM_INTERNAL_LOADING = '[Form internal] loading';
export var FORM_INTERNAL_ERROR = '[Form internal] error';
// load form
export var loadAction = function (payload) { return createAction(FORM_LOAD, payload); };
export var loadActAction = function (payload) { return createAction(FORM_ACT_LOAD, payload); };
export var loadFreeAction = function (payload) { return createAction(FORM_FREE_LOAD, payload); };
export var loadSuccessAction = function (payload) {
    return createAction(FORM_LOAD_SUCCESS, payload);
};
export var loadErrorAction = function (payload) {
    return createAction(FORM_LOAD_ERROR, payload);
};
// save and open next form
export var nextAction = function (payload) { return createAction(FORM_NEXT, payload); };
export var nextSuccessAction = function (payload) {
    return createAction(FORM_NEXT_SUCCESS, payload);
};
export var nextErrorAction = function (payload) {
    return createAction(FORM_NEXT_ERROR, payload);
};
// save form
export var saveAction = function (payload) { return createAction(FORM_SAVE, payload); };
export var saveFreeAction = function (payload) { return createAction(FORM_FREE_SAVE, payload); };
export var saveSuccessAction = function (payload) {
    return createAction(FORM_SAVE_SUCCESS, payload);
};
export var saveErrorAction = function (payload) {
    return createAction(FORM_SAVE_ERROR, payload);
};
// refresh form/update block
export var refreshAction = function (payload) { return createAction(FORM_REFRESH, payload); };
export var refreshFreeAction = function (payload) { return createAction(FORM_FREE_REFRESH, payload); };
export var refreshSuccessAction = function (payload) { return createAction(FORM_REFRESH_SUCCESS, payload); };
export var refreshErrorAction = function (payload) { return createAction(FORM_REFRESH_ERROR, payload); };
// add block
export var addBlockAction = function (payload) { return createAction(FORM_ADD_BLOCK, payload); };
export var addFreeBlockAction = function (payload) { return createAction(FORM_FREE_ADD_BLOCK, payload); };
export var addBlockSuccessAction = function (payload) { return createAction(FORM_ADD_BLOCK_SUCCESS, payload); };
export var addBlocksSuccessAction = function (payload) { return createAction(FORM_ADD_BLOCKS_SUCCESS, payload); };
export var addBlockErrorAction = function (payload) { return createAction(FORM_ADD_BLOCK_ERROR, payload); };
// remove block
export var removeBlockAction = function (payload) { return createAction(FORM_REMOVE_BLOCK, payload); };
export var removeFreeBlockAction = function (payload) { return createAction(FORM_FREE_REMOVE_BLOCK, payload); };
export var removeBlockSuccessAction = function (payload) { return createAction(FORM_REMOVE_BLOCK_SUCCESS, payload); };
export var removeBlocksSuccessAction = function (payload) { return createAction(FORM_REMOVE_BLOCKS_SUCCESS, payload); };
export var removeBlockErrorAction = function (payload) { return createAction(FORM_REMOVE_BLOCK_ERROR, payload); };
// update form state silent
export var silentUpdateAction = function (payload) { return createAction(FORM_SILENT_UPDATE, payload); };
export var silentFreeUpdateAction = function (payload) { return createAction(FORM_FREE_SILENT_UPDATE, payload); };
export var cancelAction = function () { return createAction(FORM_CANCEL, null); };
// child form
export var loadModalAction = function (payload) { return createAction(FORM_MODAL_LOAD, payload); };
export var loadModalSuccessAction = function (payload) { return createAction(FORM_MODAL_LOAD_SUCCESS, payload); };
export var loadModalErrorAction = function (payload) { return createAction(FORM_MODAL_LOAD_ERROR, payload); };
export var closeModalAction = function (payload) { return createAction(FORM_MODAL_CLOSE, payload); };
export var closeModalSuccessAction = function (payload) { return createAction(FORM_MODAL_CLOSE_SUCCESS, payload); };
export var closeModalErrorAction = function (payload) { return createAction(FORM_MODAL_CLOSE_ERROR, payload); };
export var cancelModalAction = function () { return createAction(FORM_MODAL_CANCEL, null); };
// api click
export var clickRequestAction = function (payload) { return createAction(FORM_CLICK_REQUEST, payload); };
export var clickRequestSuccessAction = function (payload) { return createAction(FORM_CLICK_REQUEST_SUCCESS, payload); };
export var clickRequestErrorAction = function (payload) { return createAction(FORM_CLICK_REQUEST_ERROR, payload); };
// navigation
export var navigateWithInitiatorAction = function (payload) {
    return createAction(FORM_NAVIGATE_WITH_INITIATOR, payload);
};
export var navigateWithParamsAction = function (payload) { return createAction(FORM_NAVIGATE_WITH_PARAMS, payload); };
// current form marker
export var changeMarkerAction = function (payload) { return createAction(FORM_CHANGE_MARKER, payload); };
// form internal action
export var internalLoadingAction = function (payload) { return createAction(FORM_INTERNAL_LOADING, payload); };
export var internalErrorAction = function (payload) { return createAction(FORM_INTERNAL_ERROR, payload); };
export var formMountAction = function (mount) { return createAction(FORM_MOUNT, { mount: mount }); };
//# sourceMappingURL=actions.js.map